import ZoomPhotoModalContent from './ZoomPhotoModalContent';

export default ZoomPhotoModalContent;
